<template>
  <div>
    <div v-if="terms" class="mb-4">
      <b-field position="is-centered" label="Terms" custom-class="has-text-centered">
        <b-checkbox v-model="termsAccepted" />
        <p class="control">
          <span>{{terms}}</span>
        </p>
      </b-field>
    </div>
    <div class="buttons is-centered">
      <a class="button is-primary"
         :href="acceptLink"
         @click.prevent="checkTermsAccepted">
        {{ cta }}
        <span v-if="price"> &nbsp; </span>
      </a>
      <a class="button is-danger is-outlined"
         :href="denyLink">
        <span>No Thanks</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cbfidItem: String,
    vtid: String,
    vendor: String,
    price: String,
    terms: String,
    serviceLinks: Array,
    duration: String
  },
  data() {
    return {
      termsAccepted: false
    }
  },
  methods: {
    checkTermsAccepted: function () {
      let { acceptLink, terms } = this;
      if (this.termsAccepted || !this.terms) {
        return window.location = `${acceptLink}${terms ? '&cbrblaccpt=true' : ''}`;
      }

      alert('You must agree to our terms by checking the box above the button.')
    }
  },
  computed: {
    cbf: function () {
      let { query } = this.$route;
      let { cbf } = query;

      return cbf ? '&cbf=' + cbf : '';
    },
    acceptLink: function () {
      let { vendor, cbfidItem, vtid, cbf } = this;
      return `https://${vendor || 'owbpremium'}.pay.clickbank.net/?cbitems=${cbfidItem}&cbur=a&vtid=${vtid || 'memup'}${cbf}`
    },
    denyLink: function () {
      let { vendor, cbfidItem, vtid, cbf } = this;
      return `https://${vendor || 'owbpremium'}.pay.clickbank.net/?cbitems=${cbfidItem}&cbur=d&vtid=${vtid || 'memup'}${cbf}`
    },
    cta: function () {
      let { price, cbfidItem, duration } = this;

      if (price && duration) {
        return `$${price} (${duration})`;
      }

      let matchingAndQualifiedPayLink = this.serviceLinks.find(link => {
        let params = new URLSearchParams(link.url.split('?')[1]);
        return params.get('cbitems') === cbfidItem && link.cta.indexOf('$') > -1;
      });

      if (matchingAndQualifiedPayLink) {
        return matchingAndQualifiedPayLink.cta;
      }

      return `Let's Do It! (${price ? '$' + price : ''} ${duration ? duration : ''})`;
    }
  }
}
</script>
